// extracted by mini-css-extract-plugin
export default {"button":"button_button__P2A2x"};